import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import React, {memo} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from 'semantic-ui-react';

import {EMPTY_CONFIG} from '../../../util/runfeed';
import * as S from './WBTablePagination.styles';

interface WBTablePaginationProps {
  loading: boolean;
  currentPage: number;
  maxPage: number;
  currentPageSize?: number;
  totalRowCount: number;
  style?: any;
  onClickPrevPage(): void;
  onClickNextPage(): void;
  setPageSize(newPageSize: number): void;
}

const options = [10, 20, 50, 100].map(size => ({
  name: `${size}`,
  value: size,
  icon: null,
  'data-test': 'pageSize-set',
}));

const WBTablePaginationComp: React.FC<WBTablePaginationProps> = ({
  loading,
  currentPage,
  maxPage,
  onClickPrevPage,
  onClickNextPage,
  setPageSize,
  totalRowCount,
  currentPageSize = EMPTY_CONFIG.pageSize,
  style,
}) => {
  function getDisplayedValue(): string {
    if (loading || totalRowCount <= 0) {
      return '0';
    }
    return `${1 + (currentPage - 1) * currentPageSize}-${Math.min(
      totalRowCount,
      currentPage * currentPageSize
    )}`;
  }

  function isPrevDisabled(): boolean {
    return loading || currentPage === 1;
  }

  function isNextDisabled(): boolean {
    return loading || currentPage === maxPage;
  }

  return (
    <div className="pagination-controls-wrapper" style={style}>
      <div className="pagination-controls">
        <S.PageSizeSelectWrapper>
          <S.PageSizeSelect
            data-test="pageSize-popup"
            aria-label="Select page size"
            disabled={loading || (isPrevDisabled() && isNextDisabled())}
            menuTheme="light"
            menuFontSize={16}
            menuLineHeight={24}
            options={options}
            value={currentPageSize}
            displayedValue={getDisplayedValue()}
            autoMenuWidth
            onSelect={value => {
              if (typeof value === 'number') {
                setPageSize(value);
              } else {
                setPageSize(parseInt(value, 10));
              }
            }}
          />
          of {totalRowCount}
        </S.PageSizeSelectWrapper>
        <Button.Group className="pagination-buttons">
          <Button
            size="tiny"
            aria-label="Go to previous page"
            className="wb-icon-button only-icon"
            disabled={isPrevDisabled()}
            aria-disabled={isPrevDisabled()}
            onClick={onClickPrevPage}>
            <LegacyWBIcon name="previous" />
          </Button>
          <Button
            size="tiny"
            aria-label="Go to next page"
            className="wb-icon-button only-icon"
            disabled={isNextDisabled()}
            aria-disabled={isNextDisabled()}
            onClick={onClickNextPage}>
            <LegacyWBIcon name="next" />
          </Button>
        </Button.Group>
      </div>
    </div>
  );
};

export const WBTablePagination = memo(WBTablePaginationComp);
